import { render } from "./PowerCleaner.vue?vue&type=template&id=7f75153f"
const script = {}

import exportComponent from "/var/www/pd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__